<template>
  <div>
    <div ref="chart" class="chart"></div>
    <NoneData v-if=" analysisData && analysisData.length===0" />
  </div>

</template>

<script>
export default {
  props: {
    analysisData: {
      type: Array,
      default: () => []
    }
  },
  mounted() {
    this.draw();
  },
  watch: {
    analysisData(value) {
      this.draw(value);
    }
  },
  methods: {
    draw(data = []) {
      echarts.init(this.$refs.chart).setOption({
        color: this.$store.state.colors,
        tooltip: {
          trigger: 'item',
          formatter(val) {
            return `<div><span>${val.name}</span> <span>${val.percent}%</span></div>`;
          }
        },
        series: [
          {
            type: 'pie',
            radius: '60%',
            center: ['50%', '50%'],
            data: data,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      });
    },
  }
};
</script>

<style scoped>
.chart {
  width: 100vw;
  height: 5rem;
}
</style>
